export default "__VITE_ASSET__ByP0sBc1__"